export default __webpack_public_path__ + "./assets/Liu__aa3f90386617c193a88927a8479e5f07.png";